// Device fingerprinting utility
// Generates a unique device ID based on browser/device characteristics

export async function getDeviceFingerprint(): Promise<string> {
  const components = [
    navigator.userAgent,
    navigator.language,
    screen.width + 'x' + screen.height,
    screen.colorDepth,
    new Date().getTimezoneOffset(),
    navigator.hardwareConcurrency || 'unknown',
    getPlatform(),
    getCanvas()
  ];

  const fingerprint = components.join('|');
  
  // Simple hash function
  return simpleHash(fingerprint);
}

function getPlatform(): string {
  return navigator.platform || 'unknown';
}

function getCanvas(): string {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) return 'no-canvas';
    
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('CLIPD', 2, 2);
    
    return canvas.toDataURL().slice(-50);
  } catch (e) {
    return 'canvas-error';
  }
}

function simpleHash(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Convert to positive hex string
  return Math.abs(hash).toString(16).padStart(8, '0');
}
